import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { publishPriceMemoMaintenanceEndpoint } from '../../../common/endpoints';

export const publishPriceMemoData = createApi(publishPriceMemoMaintenanceEndpoint, 'POST');

const PublishPriceMemo = createSlice({
  name: 'PublishPriceMemo',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(publishPriceMemoData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(publishPriceMemoData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(publishPriceMemoData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PublishPriceMemo.reducer;